import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/axios";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const [correo, setCorreo] = useState("");
  const [clave, setClave] = useState("");
  const [mostrarClave, setMostrarClave] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const redirectByRole = useCallback((rol) => {
    switch (rol) {
      case "admin":
        navigate("/admin-turnos");
        break;
      case "porteria":
        navigate("/porteria-turnos");
        break;
      case "transportista":
      case "proveedor":
      default:
        navigate("/dashboard");
        break;
    }
  }, [navigate]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    let decoded;
    try {
      decoded = jwtDecode(token);
    } catch {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return;
    }

    const now = Date.now() / 1000;
    if (decoded?.exp && decoded.exp < now) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return;
    }

    if (decoded?.requiere_cambio_clave) {
      navigate("/cambiar-clave");
      return;
    }

    if (decoded?.rol) {
      redirectByRole(decoded.rol);
    }
  }, [redirectByRole, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);

    try {
      const { data } = await api.post("/usuarios/login", { correo, clave });
      const { token } = data;

      const decoded = jwtDecode(token);

      localStorage.setItem("token", token);
      localStorage.setItem(
        "user",
        JSON.stringify({
          id: decoded.id,
          cuenta_id: decoded.cuenta_id,
          rol: decoded.rol,
          requiere_cambio_clave: decoded.requiere_cambio_clave,
        })
      );

      if (decoded.requiere_cambio_clave) {
        navigate("/cambiar-clave");
      } else {
        redirectByRole(decoded.rol);
      }
    } catch (err) {
      console.error("Error en login:", err?.response?.data || err.message);
      if (err.response?.status === 401) {
        setError("Correo o contrasena incorrectos.");
      } else {
        setError(err.response?.data?.error || "Error al iniciar sesion.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <p className="auth-card__eyebrow">Acceso seguro</p>
        <h2 className="auth-card__title">Iniciar sesion</h2>
        <p className="auth-card__subtitle">
          Ingresa con tu correo y clave para administrar turnos y movimientos.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Correo</label>
            <input
              type="email"
              className="form-control"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
              autoComplete="username"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Clave</label>
            <div className="input-group">
              <input
                type={mostrarClave ? "text" : "password"}
                className="form-control"
                value={clave}
                onChange={(e) => setClave(e.target.value)}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setMostrarClave((prev) => !prev)}
                aria-label={mostrarClave ? "Ocultar clave" : "Mostrar clave"}
              >
                {mostrarClave ? "Ocultar" : "Mostrar"}
              </button>
            </div>
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          <button type="submit" className="btn btn-primary w-100 mt-2" disabled={loading}>
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>

        <div className="mt-3 text-center">
          <Link to="/olvide-clave">Olvide mi clave</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
